<template>
    <div class="container">
        <DataAtual/>
        <b-breadcrumb :items="this.$route.meta.breadcrumb"></b-breadcrumb>
        <b-card
            class="p-1 mb-3 bg-white rounded"
            header-bg-variant="transparent"
            header-class="text-center"
            footer-bg-variant="transparent">

            <h6 v-if="tituloAnexo" class="mb-0 text-muted text-center font-weight-bold">{{tituloAnexo}}</h6>
            <h6 v-if="tituloEdicao" class="titulo mb-0 text-muted text-center">{{tituloEdicao}}</h6>
            <h6 v-if="tituloOrgao" class="mb-0 titulo text-muted text-center">{{tituloOrgao}}</h6>

            <b-embed
                class="mt-2"
                type="iframe"
                aspect="16by9"
                :src="url"
                v-if="anexoAto.documento_anexo_ato.nome_minio && url"
                allowfullscreen
            ></b-embed>
            <p v-if="!anexoAto.documento_anexo_ato.nome_minio && !carregando" class="mt-4 text-muted text-center ">Documento indisponível</p>

            <template v-slot:footer >
                <b-row >
                    <b-col class="text-left">
                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click.prevent="$router.push({ path: $route.meta.breadcrumb[$route.meta.breadcrumb.length - 2].to})"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i> Voltar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-card>
    </div>
</template>
<script>


import DataAtual from '../../components/DataAtual';
import AnexoAto from '../../models/AnexoAto'
import Ato from '../../models/Ato'
import Edicao from '../../models/Edicao'

export default {
    name: 'visualizacao',

    components: {
        DataAtual
    },

    data(){
        return {
            anexoAto: new AnexoAto(),
            url: '',
            tituloAnexo:'',
            tituloEdicao:'',
            tituloOrgao:'',
            carregando: true,
        }
    },

    methods: {        
        obterAnexoAto(id){
            return this.$api.anexoAto.obterPublicado(id)
                .then(response => {
                    return response.data && response.data.success ? new AnexoAto(response.data.data) : null;
                });
        },

        obterAto(idAto){
            return this.$api.ato.obterPublicado(idAto)
                .then(response => {
                    return response.data && response.data.success ? new Ato(response.data.data) : null;
                });
        },

        obterEdicao(idEdicao){
            return this.$api.edicao.obterPublicado(idEdicao)
                .then(response => {
                    return response.data && response.data.success ? new Edicao(response.data.data) : null;
                });
        },

    },

    async mounted(){

        this.anexoAto = await this.obterAnexoAto(this.$route.params.id);

        if(this.anexoAto){
            this.anexoAto.ato = await this.obterAto(this.anexoAto.ato_id);
            if(this.anexoAto.ato){
                this.tituloAnexo = "Anexo do ato: "+ this.anexoAto.ato.titulo_ato;
                this.tituloOrgao = this.anexoAto.ato.orgao.sigla_orgao + " - " + this.anexoAto.ato.orgao.nome_orgao;
            }

            this.anexoAto.ato.edicao = await this.obterEdicao(this.anexoAto.ato.edicao_id);
            if(this.anexoAto.ato.edicao){
                this.tituloEdicao = "Edição: "+ this.anexoAto.ato.edicao.numero_edicao +" | "+ this.$helper.getTipoEdicao(this.anexoAto.ato.edicao.tipo_edicao)  +" | Ano "+ this.anexoAto.ato.edicao.ano_romanos_edicao + " | Publicada em: "+ this.$helper.formatDataBrasil(this.anexoAto.ato.edicao.dt_publicacao);
            }

            if(this.anexoAto.documento_anexo_ato.nome_minio){
                this.$api.documento.downloadBlob(this.anexoAto.documento_anexo_ato.nome_minio, this.anexoAto.documento_anexo_ato.prefix)
                    .then(response => {
                        if(response.status === 200){
                            this.url = URL.createObjectURL(response.data);
                        }
                });
            }
        }
    }
}
</script>
<style scoped>
    .data {
        font-size: 90%;
        text-align: right;
        padding-bottom: 0.25rem;
    }

    .linkEdicao {
        font-size: 90%;
    }


    .breadcrumb{
        font-size: 0.9em;
    }

</style>